<form #formRef="ngForm" [ngClass]="{'preview-active': preview}">
	<bb-page-header [backOnMobile]="['/adservices/vastservice']" [icon]="'cloud-upload'" [title]="'VAST_SERVICE' | translate">
		<ul class="tabs" *ngIf="mediaclip">
			<li>
				<a [routerLink]="['/adservices/vastservice/creatives', activeId, 'metadata']" routerLinkActive="active">
					<i class="fa fa-tags"></i> {{ 'METADATA' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/vastservice/creatives', activeId, 'end-screen']" routerLinkActive="active">
					<i class="fa fa-image"></i> {{ 'END-SCREEN' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/vastservice/creatives', activeId, 'react']" routerLinkActive="active">
					<i class="fa fa-comments-o"></i> {{ 'REACT' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/vastservice/creatives', activeId, 'tags']" routerLinkActive="active">
					<i class="fa fa-code"></i> {{ 'TAGS' | translate }}
				</a>
			</li>

		</ul>

		<bb-status *ngIf="mediaclip" [(ngModel)]="mediaclip.status" name="status"></bb-status>

	</bb-page-header>

	<div class="body-column tab-container" [ngClass]="{'fullsize': activeTab === 'react'}">
		<vast-details-metadata *ngIf="mediaclip" [form]="form" [creative]="mediaclip" [hidden]="activeTab !== 'metadata'"></vast-details-metadata>
		<vast-details-endscreen *ngIf="mediaclip" [form]="form" [creative]="mediaclip" [hidden]="activeTab !== 'end-screen'"></vast-details-endscreen>
		<vast-details-react *ngIf="mediaclip" [form]="form" [creative]="mediaclip" [hidden]="activeTab !== 'react'"></vast-details-react>
		<bb-vast-creative-preview *ngIf="mediaclip && activeTab === 'tags'" [mediaclip]="mediaclip"></bb-vast-creative-preview>
	</div>
	<div class="body-column preview-container" *ngIf="activeTab !== 'react'">
		<h3 class="mobile">{{'PREVIEW' | translate}}</h3>
		<ng-container *ngIf="entity && mediaclip.id">
			<div [ngSwitch]="mediaclip.mediatype" class="preview-wrapper">
				<div *ngSwitchCase="'video'">
					<bb-player
						(onPlayerCreated)="playerCreated($event)"
						[mediaclip]="mediaclip" 
						[autoplay]="false"
						[playoutOverrides]="{width: '100%', responsiveSizing: 'true', allowImageSequence:'false', fullScreen:'Hide'}"></bb-player>
				</div>
				<div *ngSwitchCase="'audio'">
					<bb-player
						(onPlayerCreated)="playerCreated($event)"
						[mediaclip]="mediaclip" 
						[autoplay]="false"
						[playoutOverrides]="{responsiveSizing:'false', height:'30',showBigPlayButton:'false',showBigReplayButton:'false',qualitySelector:'hide',fullScreen:'hide',volumeOrientation:'horizontal',timeDisplay:'Show progress time',controlBar:'Show',alphaControlBar:'100'}"></bb-player>
				</div>
				<!-- <img *ngSwitchCase="'image'" [src]="getThumbnail(mediaclip.id,360,180)" class="thumb" /> -->
			</div>
			<div class="creative-actions">
				<span *ngIf="mediaclip.mediatype==='video'" class="button" [ngClass]="{'active': preview}" (click)="preview = !preview"><i class="fa fa-arrows-h"></i>{{ 'PREVIEW' | translate }}</span>
			</div>
		</ng-container>
		<div class="entity-technical-details" *ngIf="mediaclip">
			<bb-entity-details
				[entity]="mediaclip"
			></bb-entity-details>

			<h3 *ngIf="mediaclip?.id">{{ 'ANALYTICS' | translate }}</h3>
			<div *ngIf="mediaclip?.id" class="button" (click)="showEngagement(mediaclip?.id, mediaclip?.title)">
				{{ 'SHOW_ENGAGEMENT' | translate }}
			</div>

			<ng-container *ngIf="mediaclip?.mediatype === 'video' || mediaclip?.mediatype === 'audio'">
				<div [hasPermission]="'interactivity'">
					<h3>{{ 'INTERACTIVITY' | translate }}</h3>
					<div *ngIf="!mediaclip?.timelines || !mediaclip?.timelines[0]"><a class="button" [routerLink]="['/library/interactivity/new']" [queryParams]="{ parentEntityType: 'MediaClip', parentEntityId: mediaclip.id}">{{ 'ADD_INTERACTIVITY' | translate }}</a></div>
					<div *ngIf="mediaclip?.timelines && mediaclip?.timelines[0]"><a class="button" [routerLink]="['/library/interactivity/' + mediaclip.timelines[0].id]">{{ 'EDIT_INTERACTIVITY' | translate }}</a></div>
				</div>
			</ng-container>
		</div>
	</div>
</form>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" (onDelete)="delete()" [form]="form" [entity]="mediaclip">
	<span *ngIf="creative && creative.mediatype==='video' && activeTab !== 'react'" class="action-button" [ngClass]="{'active': preview}" (click)="preview = !preview">{{ 'PREVIEW' | translate }}</span>
</bb-actions-bar>
